import { FunctionComponent } from 'react';
import VerticalContainer from '../common/VerticalContainer';
import PageContainer from '../productPage/tableComponents/PageContainer';
import { Button, Typography } from '@mui/material';

interface ErrNoResultTemplateProps {
    errorMsg: string;
}

const ErrNoResultTemplate: FunctionComponent<ErrNoResultTemplateProps> = ({ errorMsg }) => {
    return (
        <VerticalContainer sx={{ height: '218px', backgroundColor: 'white' }}>
            <PageContainer
                sx={{ backgroundColor: 'white' }}
                innerSx={{
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                }}
            >
                <Typography
                    sx={{
                        fontFamily: 'Poppins',
                        fontSize: '40px',
                        fontWeight: 600,
                        lineHeight: '60px',
                        textAlign: 'center',
                    }}
                >
                    {errorMsg}
                </Typography>
            </PageContainer>
            <PageContainer
                sx={{ backgroundColor: 'white' }}
                innerSx={{
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                }}
            >
                <Button
                    onClick={() => (window.location.href = '/')}
                    sx={{
                        width: '150px',
                        height: '40px',
                        padding: '8px 10px 8px 10px',
                        gap: '10px',
                        borderRadius: '5px',
                        backgroundColor: ' #E5673E',
                        color: 'white',
                        fontSize: '16px',
                        fontFamily: 'Poppins',
                        fontWeight: 500,
                        lineHeight: '24px',
                        transition: 'none',
                        textTransform: 'capitalize',
                        '&:hover': {
                            background: 'linear-gradient(0deg, #B75332 0%, #E5673E 100%)',
                        },
                    }}
                >
                    Take Me Home
                </Button>
            </PageContainer>
        </VerticalContainer>
    );
};

export default ErrNoResultTemplate;
